import React, { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import { useObserver } from 'mobx-react-lite';
import { useStores } from '../../../store';
import { DownloadResume } from '../resume_output';

const Resume12 = () => {
  const { ResumeStore } = useStores();
  const resumeRef = useRef(null);

  const handleDownload = useReactToPrint({
    content: () => resumeRef.current,
  });

  return useObserver(() => (
    <>
      <DownloadResume onClick={handleDownload} />
      <div className="flex flex-col w-full items-center bg-gray-100 p-6">
        <div className="flex w-full max-w-4xl bg-white border border-gray-300 shadow-lg" ref={resumeRef}>
          <div className="flex flex-col bg-gray-200 p-6 w-1/3 border-r border-gray-300">
            <h1 className="text-2xl text-red-700 mb-4">
              {`${ResumeStore?.resumeBuilder?.personalDetails.firstName} ${ResumeStore?.resumeBuilder?.personalDetails.lastName}`}
            </h1>
            <p className="text-sm mb-4">
              {ResumeStore?.resumeBuilder?.personalDetails.address},<br />
              {ResumeStore?.resumeBuilder?.personalDetails.city}, {ResumeStore?.resumeBuilder?.personalDetails.postalCode}<br />
              {ResumeStore?.resumeBuilder?.personalDetails.email}<br />
              {ResumeStore?.resumeBuilder?.personalDetails.phone}
            </p>
            <div className="mb-4">
              <h2 className="text-xl text-red-700 mb-2">KEY SKILLS</h2>
              <ul className="list-disc list-inside text-sm">
                {ResumeStore?.resumeBuilder?.skills.map((skill, index) => (
                  <li key={index}>{skill}</li>
                ))}
              </ul>
            </div>
            <div>
              <h2 className="text-xl text-red-700 mb-2">CERTIFICATIONS</h2>
              {ResumeStore?.resumeBuilder?.extraCurricularActivities.map((eca, index) => (
                <p key={index}>{eca.functionTitle}</p>
              ))}
            </div>
          </div>
          <div className="flex flex-col p-6 w-2/3">
            <p className="text-sm mb-6">{ResumeStore?.resumeBuilder?.profileSummary}</p>
            <div className="mb-4">
              <h2 className="text-xl text-red-700 mb-2">EDUCATION</h2>
              {ResumeStore?.resumeBuilder?.education.map((edu, index) => (
                <div key={index} className="mb-4">
                  <p className="font-bold text-sm">{edu.degree}</p>
                  <p className="text-sm">{edu.school},<br />{edu.city}<br />{edu.startDate} - {edu.endDate}</p>
                </div>
              ))}
            </div>
            <div>
              <h2 className="text-xl text-red-700 mb-4">PROFESSIONAL EXPERIENCE</h2>
              {ResumeStore?.resumeBuilder?.employementHistory.map((job, index) => (
                <div key={index} className="mb-6">
                  <h3 className="text-lg mb-2">{job.jobTitle}</h3>    
                  <p className="text-sm mb-2">{job.company}, {job.city} | {job.startDate} - {job.endDate}</p>
                  <ul className="list-disc list-inside text-sm">
                    {job.description?.split('\n')?.map((desc, i) => (
                      <li key={i}>{desc}</li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  ));
};

export default Resume12;
